var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.permission?.noticeMessage || _vm.permission?.noticeId)?_c('div',{staticClass:"permission-notice"},[_c('span',[_vm._v(_vm._s(_vm.permission?.noticeMessage ?? ''))]),(_vm.permission?.noticeId)?_c('button',{on:{"click":_setup.onClick}},[_vm._v("자세히보기")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }